import React, { useContext } from 'react';
import { RecordCardManager } from '../../../store/shared/RecordCardManager';

interface RecordCardContextProps {
  recordCardManager: RecordCardManager;
}

export const RecordCardContext = React.createContext<
  RecordCardContextProps | undefined
>(undefined);

export const useRecordCardContext = (): RecordCardContextProps => {
  const value = useContext(RecordCardContext);

  if (value) return value;

  throw new Error(
    'Контекст RecordCardContext не был инициализирован перед обращением',
  );
};
